<script>
    export let title;
    export let url;
    export let description;
    export let image = '';
    export let ldJSON = undefined;

    // set openGraph Image if one or use default
    const openGraphImage = image ? image : 'https://caktusvape.co.nz/images/CaktusOpenGraph.png';

    // Strip search params from canonical url
    const cleanUrl = `${url?.origin}${url?.pathname}`;

    // clean spam charchters from descriptions
    description = description?.replace(/Â|â€™/g, '');
</script>

<svelte:head>
    <!--Page Meta-->
    <title>{title}</title>
    <meta name="description" content={description} />
    <link rel="canonical" href={cleanUrl} />

    <!--OpenGraph Meta-->
    <meta property="og:title" content={title} />
    <meta property="og:description " content={description} />
    <meta property="og:type" content="website" />
    <meta property="og:site_name" content="Caktus Vape" />
    <meta property="og:url" content={url} />
    <meta property="og:image" content={openGraphImage} />

    <!--Strutured Data-->
    {#if ldJSON}
        {@html `<script type="application/ld+json">${JSON.stringify(ldJSON, null, 2)}</script>`}
    {/if}
</svelte:head>
